import { isNullOrUndefined } from "../../../common/utils";
import { Operators } from "../model/Operators";

export function isNullCondition(conditionNode) {
  if (isNullOrUndefined(conditionNode) || conditionNode.operator === Operators.noConditionNull) {
    return true;
  } else return false;
}
